export default __webpack_public_path__ + "static/media/pdf.d46f298d.svg";